import { ContractAddress } from '../../constants';
import type { MovieNFTOptions, NFTMetadataInput } from '../nft.types';
import { buildNFTs } from '../nft.utils';

export const MOVIE_1_OPTIONS: MovieNFTOptions = {
  contractAddress: ContractAddress.MogulMovieNft,
  label: 'TERMINAL_STATION',
  movieTitle: 'Terminal Station',
  movieSynopsis:
    'A retired hitman for the Mafia is waiting in a train station to leave his life behind when he unintentionally steps in to save a pregnant woman running away from her husband, an ex-Mafia boss. The Hitman must now use all of his skills to protect the woman and himself from the group he used to work for.',
  startId: 1,
  count: 1,
  previewMediaIpfsId: 'Qmdo4Kt37F4D4NtCaDAjPhGbhpTSVwDwSywAr5iG4u2As3',
  rawMediaIpfsId: 'QmNWoiaLbqRkiLs2wKqBUw7Drf9qxeTyEKs8bZsNoPWrkm',
};

export const MOVIE_2_OPTIONS: MovieNFTOptions = {
  contractAddress: ContractAddress.MogulMovieNft,
  label: 'DEVILREAUX',
  movieTitle: 'Devilreaux',
  movieSynopsis:
    'Devilreaux and his family were killed unjustly in the 1800s and harness a forbidden Voodoo to avenge their murders. Movie takes place in present day where an unwitting group of teenagers accidentally bring Devilreaux back to life to wreak vengeance again.',
  startId: 2,
  count: 1,
  previewMediaIpfsId: 'QmYCcTfqMqt7pW8ahPiHEdMzTRrGeXfxfhHpoBGqSYumpp',
  rawMediaIpfsId: 'QmY4upXaa1M6i1S3qmrSdJRQLSjYQvfgxvZqnV7g6C1DFF',
};

export const MOVIE_3_OPTIONS: MovieNFTOptions = {
  contractAddress: ContractAddress.MogulMovieNft,
  label: 'MR_9',
  movieTitle: 'MR-9',
  movieSynopsis:
    'MR9, a spy with a mysterious past, joins forces with an elite group of international Agents, racing against the clock to stop a terrorist attack set to happen during the World Peace Summit in Bangladesh.',
  startId: 3,
  count: 1,
  previewMediaIpfsId: 'QmSPYs3qUY2fdG5TeWn6toTkYUWVB5g9S6bFg45d1xG1o3',
  rawMediaIpfsId: 'Qmf9CkqHhPotcVNfU8voACT2NskgD7bZ8DZwsczcCtHX6h',
};

export const buildMoviesNftInput = (
  options: MovieNFTOptions,
): NFTMetadataInput => {
  const properties = {
    contract_address: {
      label: 'Contract Address',
      type: 'string',
      value: options.contractAddress,
    },
    title: {
      label: 'Title',
      type: 'string',
      value: options.movieTitle,
    },
    description: {
      label: 'Description',
      type: 'string',
      value: options.movieSynopsis,
    },
    author: { label: 'Author', type: 'string', value: 'Mogul Productions' },
    external_url: {
      label: 'External URL',
      type: 'string',
      value: `https://v1.mglnft.com/${options.contractAddress.toLowerCase()}/${
        options.startId
      }`,
    },
    image_url: {
      label: 'Image URL',
      type: 'string',
      value: `ipfs://${options.previewMediaIpfsId}`,
    },
    image_original_url: {
      label: 'Original Image URL',
      type: 'string',
      value: `ipfs://${options.rawMediaIpfsId}`,
    },
    media_orientation: {
      label: 'Media Orientation',
      type: 'string',
      value: 'portrait',
    },
    background_color: {
      label: 'Background Color',
      type: 'string',
      value: '000000',
    },
    collection_label: {
      label: 'Collection',
      type: 'string',
      value: 'Mogul Movie Voting',
    },
    total_supply: {
      label: 'Total Supply',
      type: 'int',
      value: 1,
    },
    issue_date: {
      label: 'Issue Date',
      type: 'date',
      value: 1626825600,
    },
  };
  return {
    title: properties.title.value,
    description: properties.description.value,
    properties,
    attributes: Object.keys(properties)
      .filter(k => ['author'].includes(k))
      .map(propertyKey => properties[propertyKey as keyof typeof properties]),
  };
};

export const buildMoviesNfts = () => {
  return [MOVIE_1_OPTIONS, MOVIE_2_OPTIONS, MOVIE_3_OPTIONS].reduce<
    ReturnType<typeof buildNFTs>
  >((acc, options) => {
    return [...acc, ...buildNFTs(options, () => buildMoviesNftInput(options))];
  }, []);
};
